import { useDataValue } from 'Simple/Data.js'
import { formatTzDate } from 'Data/format.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  let appointment_type_id = useDataValue({
    context: 'appointment_overlay',
    path: 'appointment_type_id',
    viewPath: props.viewPath,
  })
  let appointment_id = useDataValue({
    context: 'appointment_overlay',
    path: 'appointment_id',
    viewPath: props.viewPath,
  })
  let location_id = useDataValue({
    context: 'tab',
    path: 'selected.location_id',
    viewPath: props.viewPath,
  })
  let time_zone_id = useDataValue({
    context: 'tab',
    path: 'selected.time_zone_id',
    viewPath: props.viewPath,
  })
  let start_date = useDataValue({
    context: 'date_select',
    path: 'start_date',
    viewPath: props.viewPath,
  })
  let end_date = useDataValue({
    context: 'date_select',
    path: 'end_date',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      location_id,
      appointment_type_id,
      start_date: formatTzDate(start_date, 'yyyy-MM-dd', time_zone_id),
      end_date: formatTzDate(end_date, 'yyyy-MM-dd', time_zone_id),
      // to ignore when rescheduling
      appointment_id:
        (appointment_id === 'new' ? null : appointment_id) || null,
    },
    pause:
      !location_id ||
      !time_zone_id ||
      !appointment_type_id ||
      !start_date ||
      !end_date,
    requestPolicy: 'network-only',
  }
}
